import * as React from 'react';
import { Link } from 'react-router-dom';

import Button from '@/components/elements/Button/BaseButton';

import { ButtonContainer, ContentBox, TitleTertiary } from '../style';
import { CenteredText } from './style';

const GuideSignup: React.FC = () => {
  return (
    <ContentBox>
      <TitleTertiary>さっそくDMM競輪をはじめる</TitleTertiary>
      <CenteredText>
        DMM競輪を利用するにはDMM会員登録（無料会員登録）が必要です。
      </CenteredText>
      <ButtonContainer>
        <Link to="/signup">
          <Button
            type="button"
            bgColor="primary"
            size="m"
            radius="l"
            height="56px"
            fontWeight="bold"
          >
            利用登録はこちら
          </Button>
        </Link>
      </ButtonContainer>
    </ContentBox>
  );
};

export default GuideSignup;
